export enum ViewTab {
  DETAILS = 'DETAILS',
  MATERIALS = 'MATERIALS',
  DOCUMENTS = 'DOCUMENTS',
}
